<template>
    <div class="container container-main-noticies">
        <div class="row row__primary-block">
            <div class="col-12 col-lg-12" v-if="full">
                <SuperLink
                    class="container-main-noticias__banner-full"
                    :href="full.link">
                    <div class="container-main-noticias__banner-content">
                        <span v-if="full.hat">{{full.hat}}</span>
                        <h1>{{full.title}}</h1>
                        <p>{{full.subtitle}}</p>
                    </div>
                    <figure>
                        <img v-if="full.image" :src="utils.image(full.image, 832, 456)" :alt="full.title">
                    </figure>
                </SuperLink>
            </div>
            <div class="col-12 col-lg-6 col-variation-3">
                <div class="row" v-if="main">
                    <div class="col-12 col-lg-12">
                        <SuperLink 
                            class="main-noticies__top main-noticies__top--first" 
                            :href="main.link" 
                            target="_self">
                            <p class="noticies__title noticies__title--blue">
                                <strong>{{main.title}}</strong>
                            </p>
                            <p class="noticies__subtitle">{{main.subtitle}}</p>
                        </SuperLink>
                    </div>
                </div>
                <div class="row" v-if="related">
                    <div class="col-12">
                        <template v-for="r in related">
                            <SuperLink
                                :href="r.link" 
                                :key="r.id" 
                                class="main-noticies__top main-noticies__top--second" 
                                target="_self">
                                <p class="noticies__title noticies__title--blue">
                                    <strong>• {{r.title || r.link.title}}</strong>
                                </p>
                            </SuperLink>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 row__primary-block-3">
                <div class="row" v-if="big">
                    <div class="col-12 col-md-6">
                        <div class="slide --header-banner">
                            <span class="counter-component"></span>
                            <div class="swiper-button-prev swiper-button-prev--hero-banner"></div>
                            <div class="swiper-button-next swiper-button-next--hero-banner"></div>
                            <div class="swiper-container --hero-banner">
                                <swiper 
                                    ref="mySwiper" 
                                    :options="swiperOptions" 
                                    class="swiper-wrapper">
                                    <swiper-slide class="swiper-slide" v-for="noticia in big" :key="noticia.id">
                                        <SuperLink :href="noticia.link" target="_self" class="noticies-item">
                                            <div class="noticies-item--image">
                                                <img v-if="noticia.image" :src="utils.image(noticia.image, 256, 304)" alt="">
                                                <img v-else-if="noticia.link.image" :src="utils.image(noticia.link.image, 256, 304)" alt="">
                                            </div>
                                            <div class="noticies-item--info">
                                                <p class="noticies__label">
                                                    <strong v-if="noticia.hat">{{noticia.hat}}</strong>
                                                    <strong v-else-if="noticia && noticia.link && noticia.link.editorial">{{noticia.link.editorial.title}}</strong>
                                                </p>
                                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                                            </div>
                                        </SuperLink>
                                    </swiper-slide>
                                </swiper>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <Tabs>
                            <SuperLink v-if="simple && simple.link" :href="simple.link" target="_self" class="noticies-item noticies-item__tab --header-5">
                                <p class="noticies__label">
                                    <strong v-if="simple.hat">{{simple.hat}}</strong>
                                    <strong v-else-if="simple && simple.link && simple.link.editorial">{{simple.link.editorial.title}}</strong>
                                </p>
                                <p class="noticies__title noticies__title--blue noticies__title--small"><strong>{{simple.title}}</strong></p>
                            </SuperLink>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>

        <div class="row row__secondary-block row__secondary-block--variation-3" v-if="small">
            <div class="col-12 col-md-4 col-lg-2" v-for="sm in small" :key="sm.id">
                <SmallItem :item="sm" />
            </div>
        </div>
        <Blogs class="--show-mobile" />
    </div>
</template>

<script>
import utils from '@/utils'
import SmallItem from '@/components/home/header/Small'
import Tabs from '@/components/home/header/Tabs'
import Blogs from '@/components/home/Blogs'

import SuperLink from '@/components/SuperLink'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

export default {
    name: "Header05",
    props:{
        'full': Object,
        'main': Object, 
        'small': Array, 
        'simple': Object, 
        'big': Array,
        'related': Array,
    },
    components: {SmallItem, Tabs, SuperLink, Swiper, SwiperSlide, Blogs},
    directives: {
        swiper: directive
    },
    data(){
        return {
            utils:utils,
            swiper: null,
            swiperOptions: {
                autoplay: {
                    slidesPerView: 1,
                    delay: 5000,
                    disableOnInteraction: false
                },
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next--hero-banner',
                    prevEl: '.swiper-button-prev--hero-banner',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 1,
                    },
                    0: {
                        slidesPerView: 1,
                    }
                },
                pagination: {
                    el: '.counter-component',
                    type: 'fraction'
                },
            }
        }
    },
}
</script>